const keyProvisionsInternationalTemplate = `
<!DOCTYPE html>
<html>
  <head></head>
  <body>  
    <h2 class="pdf-table-heading">Key Provisions</h2>
    
    <!-- Key Contacts table for International -->
    <div class="row">
      <h3 class="pdf-table-sub-heading">Key Contacts</h3>
      <table id="print-pdf-table" class="key-provision-table" style="page-break-inside: avoid;">
        <tr>
          <th></th>
          <th>Firm Name</th>
          <th>Key Contact</th>
          <th>Email</th>
          <th>Risk rating</th>
        </tr>
        {{#if keyProvisionData.planningAdviser.firmName}}
        <tr>
          <td>Planning Advisor</td>
          <td>{{{keyProvisionData.planningAdviser.firmName}}}</td>
          <td>{{{keyProvisionData.planningAdviser.keyContacts}}}</td>
          <td>{{{keyProvisionData.planningAdviser.email}}}</td>
          <td>{{{keyProvisionData.planningAdviser.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.buildingContractors.firmName}}
        <tr>
          <td>Building Contractors</td>
          <td>{{{keyProvisionData.buildingContractors.firmName}}}</td>
          <td>{{{keyProvisionData.buildingContractors.keyContacts}}}</td>
          <td>{{{keyProvisionData.buildingContractors.email}}}</td>
          <td>{{{keyProvisionData.buildingContractors.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.leasingAgents.firmName}}
        <tr>
          <td>Leasing agent(s)</td>
          <td>{{{keyProvisionData.leasingAgents.firmName}}}</td>
          <td>{{{keyProvisionData.leasingAgents.keyContacts}}}</td>
          <td>{{{keyProvisionData.leasingAgents.email}}}</td>
          <td>{{{keyProvisionData.leasingAgents.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.propertyManagingAgent.firmName}}
        <tr>
          <td>Property Managing Agent</td>
          <td>{{{keyProvisionData.propertyManagingAgent.firmName}}}</td>
          <td>{{{keyProvisionData.propertyManagingAgent.keyContacts}}}</td>
          <td>{{{keyProvisionData.propertyManagingAgent.email}}}</td>
          <td>{{{keyProvisionData.propertyManagingAgent.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.operator.firmName}}
        <tr>
          <td>Operator</td>
          <td>{{{keyProvisionData.operator.firmName}}}</td>
          <td>{{{keyProvisionData.operator.keyContacts}}}</td>
          <td>{{{keyProvisionData.operator.email}}}</td>
          <td>{{{keyProvisionData.operator.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.thirdPartyAssetManager.firmName}}
        <tr>
          <td>Third Party Asset Manager</td>
          <td>{{{keyProvisionData.thirdPartyAssetManager.firmName}}}</td>
          <td>{{{keyProvisionData.thirdPartyAssetManager.keyContacts}}}</td>
          <td>{{{keyProvisionData.thirdPartyAssetManager.email}}}</td>
          <td>{{{keyProvisionData.thirdPartyAssetManager.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#each keyProvisionData.jvPartnerData}}
        <tr>
          <td>JV Partner {{add @index 1}}</td>
          <td>{{{this.firmName}}}</td>
          <td>{{{this.keyContacts}}}</td>
          <td>{{{this.email}}}</td>
          <td>{{{this.riskRating}}}</td>
        </tr>
        {{/each}}
      </table>
    </div>

    <!-- Holding Structure Section -->
    {{#if keyProvisionData.holdingStructure.specialPurposeVehicle}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Holding Structure</h3>
      <table id="print-pdf-table" class="key-provision-table">
        <tr>
          <th>Structure Type</th>
          <th>Details</th>
        </tr>
        <tr>
          <td>Special purpose vehicle</td>
          <td>{{{keyProvisionData.holdingStructure.specialPurposeVehicle}}}</td>
        </tr>
        {{#if keyProvisionData.holdingStructure.holdingCompany}}
        <tr>
          <td>Holding company</td>
          <td>{{{keyProvisionData.holdingStructure.holdingCompany}}}</td>
        </tr>
        {{/if}}
      </table>
    </div>
    {{else}}{{#if keyProvisionData.holdingStructure.holdingCompany}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Holding Structure</h3>
      <table id="print-pdf-table" class="key-provision-table">
        <tr>
          <th>Structure Type</th>
          <th>Details</th>
        </tr>
        <tr>
          <td>Holding company</td>
          <td>{{{keyProvisionData.holdingStructure.holdingCompany}}}</td>
        </tr>
      </table>
    </div>
    {{/if}}{{/if}}
    
    <!-- Third Party Insurer Section -->
    <div class="row">
      <h3 class="pdf-table-sub-heading">Third Party Insurer</h3>
      <div style="margin-bottom: 10px;">
        <span style="font-weight: bold;">Do you have a third party insurer?<br> </span>
        <span style="margin-left: 10px;">
          {{#if keyProvisionData.hasThirdPartyInsurer}}
          Yes 
          {{else}}
          No
          {{/if}}
        </span>
      </div>
      {{#if keyProvisionData.hasThirdPartyInsurer}}
      <table id="print-pdf-table" class="key-provision-table">
        <tr>
          <th>Firm Name</th>
          <th>Key Contact</th>
          <th>Email</th>
          <th>Phone Number</th>
        </tr>
        <tr>
          <td>{{{keyProvisionData.thirdPartyInsurer.firmName}}}</td>
          <td>{{{keyProvisionData.thirdPartyInsurer.keyContacts}}}</td>
          <td>{{{keyProvisionData.thirdPartyInsurer.email}}}</td>
          <td>{{{keyProvisionData.thirdPartyInsurer.phoneNumber}}}</td>
        </tr>
      </table>
      {{/if}}
    </div>

    <!-- Comments Section -->
    <div>
    <h3 class="pdf-table-sub-heading">Agreement Provisions</h3>
      <table id="table-comment"> 
        {{#if KeyProvisionComment.mangementComment_date}}
        <tr><th><h3>Management Agreement:</h3></th></tr>
        <tr><th>Name/ Parties/ Date</th></tr>
        <tr><td>{{{KeyProvisionComment.mangementComment_date}}}</td></tr>
        {{#if KeyProvisionComment.mangementComment_fee}}
        <tr><th>Management Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.mangementComment_fee}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.mangementComment_otherFee}}
        <tr><th>Other Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.mangementComment_otherFee}}}</td></tr>
        {{/if}}
        {{else}}{{#if KeyProvisionComment.mangementComment_fee}}
        <tr><th><h3>Management Agreement:</h3></th></tr>
        <tr><th>Name/ Parties/ Date</th></tr>
        {{#if KeyProvisionComment.mangementComment_date}}
        <tr><td>{{{KeyProvisionComment.mangementComment_date}}}</td></tr>
        {{/if}}
        <tr><th>Management Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.mangementComment_fee}}}</td></tr>
        {{#if KeyProvisionComment.mangementComment_otherFee}}
        <tr><th>Other Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.mangementComment_otherFee}}}</td></tr>
        {{/if}}
        {{else}}{{#if KeyProvisionComment.mangementComment_otherFee}}
        <tr><th><h3>Management Agreement:</h3></th></tr>
        <tr><th>Name/ Parties/ Date</th></tr>
        {{#if KeyProvisionComment.mangementComment_date}}
        <tr><td>{{{KeyProvisionComment.mangementComment_date}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.mangementComment_fee}}
        <tr><th>Management Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.mangementComment_fee}}}</td></tr>
        {{/if}}
        <tr><th>Other Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.mangementComment_otherFee}}}</td></tr>
        {{/if}}{{/if}}{{/if}}

        {{#if KeyProvisionComment.leasebroker_name}}
        <tr><th><h3>Leasing Broker:</h3></th></tr>
        <tr><th>Name</th></tr>
        <tr><td>{{{KeyProvisionComment.leasebroker_name}}}</td></tr>
        {{#if KeyProvisionComment.leasebroker_fee}}
        <tr><th>Management Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.leasebroker_fee}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.leasebroker_otherfee}}
        <tr><th>Other Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.leasebroker_otherfee}}}</td></tr>
        {{/if}}
        {{else}}{{#if KeyProvisionComment.leasebroker_fee}}
        <tr><th><h3>Leasing Broker:</h3></th></tr>
        <tr><th>Name</th></tr>
        {{#if KeyProvisionComment.leasebroker_name}}
        <tr><td>{{{KeyProvisionComment.leasebroker_name}}}</td></tr>
        {{/if}}
        <tr><th>Management Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.leasebroker_fee}}}</td></tr>
        {{#if KeyProvisionComment.leasebroker_otherfee}}
        <tr><th>Other Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.leasebroker_otherfee}}}</td></tr>
        {{/if}}
        {{else}}{{#if KeyProvisionComment.leasebroker_otherfee}}
        <tr><th><h3>Leasing Broker:</h3></th></tr>
        <tr><th>Name</th></tr>
        {{#if KeyProvisionComment.leasebroker_name}}
        <tr><td>{{{KeyProvisionComment.leasebroker_name}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.leasebroker_fee}}
        <tr><th>Management Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.leasebroker_fee}}}</td></tr>
        {{/if}}
        <tr><th>Other Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.leasebroker_otherfee}}}</td></tr>
        {{/if}}{{/if}}{{/if}}

        {{#if KeyProvisionComment.jvagreement_KeyDecision}}
        <tr><th><h3>JV Agreement:</h3></th></tr>
        <tr><th>Key Major Decisions</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_KeyDecision}}}</td></tr>
        {{#if KeyProvisionComment.jvagreement_fee}}
        <tr><th>Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_fee}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.jvagreement_liquidProvision}}
        <tr><th>Liquidity Provisions</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_liquidProvision}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.jvagreement_Keyprovision}}
        <tr><th>Other Key Provisions</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_Keyprovision}}}</td></tr>
        {{/if}}
        {{else}}{{#if KeyProvisionComment.jvagreement_fee}}
        <tr><th><h3>JV Agreement:</h3></th></tr>
        <tr><th>Key Major Decisions</th></tr>
        {{#if KeyProvisionComment.jvagreement_KeyDecision}}
        <tr><td>{{{KeyProvisionComment.jvagreement_KeyDecision}}}</td></tr>
        {{/if}}
        <tr><th>Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_fee}}}</td></tr>
        {{#if KeyProvisionComment.jvagreement_liquidProvision}}
        <tr><th>Liquidity Provisions</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_liquidProvision}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.jvagreement_Keyprovision}}
        <tr><th>Other Key Provisions</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_Keyprovision}}}</td></tr>
        {{/if}}
        {{else}}{{#if KeyProvisionComment.jvagreement_liquidProvision}}
        <tr><th><h3>JV Agreement:</h3></th></tr>
        <tr><th>Key Major Decisions</th></tr>
        {{#if KeyProvisionComment.jvagreement_KeyDecision}}
        <tr><td>{{{KeyProvisionComment.jvagreement_KeyDecision}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.jvagreement_fee}}
        <tr><th>Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_fee}}}</td></tr>
        {{/if}}
        <tr><th>Liquidity Provisions</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_liquidProvision}}}</td></tr>
        {{#if KeyProvisionComment.jvagreement_Keyprovision}}
        <tr><th>Other Key Provisions</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_Keyprovision}}}</td></tr>
        {{/if}}
        {{else}}{{#if KeyProvisionComment.jvagreement_Keyprovision}}
        <tr><th><h3>JV Agreement:</h3></th></tr>
        <tr><th>Key Major Decisions</th></tr>
        {{#if KeyProvisionComment.jvagreement_KeyDecision}}
        <tr><td>{{{KeyProvisionComment.jvagreement_KeyDecision}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.jvagreement_fee}}
        <tr><th>Fees</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_fee}}}</td></tr>
        {{/if}}
        {{#if KeyProvisionComment.jvagreement_liquidProvision}}
        <tr><th>Liquidity Provisions</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_liquidProvision}}}</td></tr>
        {{/if}}
        <tr><th>Other Key Provisions</th></tr>
        <tr><td>{{{KeyProvisionComment.jvagreement_Keyprovision}}}</td></tr>
        {{/if}}{{/if}}{{/if}}{{/if}}
      </table>
    </div>
  </body>
</html>
`;

export default keyProvisionsInternationalTemplate;